import { render, staticRenderFns } from "./TransactionsXLS.vue?vue&type=template&id=0962f126"
import script from "./TransactionsXLS.vue?vue&type=script&lang=js"
export * from "./TransactionsXLS.vue?vue&type=script&lang=js"
import style0 from "./TransactionsXLS.vue?vue&type=style&index=0&id=0962f126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports